<template>
	<base-layout :doSkipHeader="true">
		<template v-slot:main>
			<div >

				<!-- <form @submit.prevent="onSubmit">
          <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            size="invisible"
            :sitekey="recaptchaKey">
          </vue-recaptcha>
          <button type="submit">Submit</button>
        </form> -->


				<div class="bg-white">
				  <div class="mx-auto py-12 px-4 max-w-screen-xl sm:px-6 lg:px-8 lg:py-24">
				    <div class="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-2">
				      <div class="space-y-5 sm:space-y-4">
				        <h2 class="text-2xl sm:text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl mb-2">Get in touch</h2>
				        <p class="text-xl leading-7 text-gray-500">We're happy to help. And please remember, trade safe!</p>
				      </div>
				      <div class="lg:col-span-2">
				        <ul class="space-y-4 sm:grid sm:grid-cols-2 sm:gap-12 sm:space-y-0 lg:col-gap-8">
				          <li v-for='contact in contacts' :key='contact.name'>
				            <div class="flex items-center space-x-4 lg:space-x-6 py-4 sm:py-0">
				              <img class="w-16 h-16 rounded-full lg:w-20 lg:h-20" :src="contact.picUrl" alt="">
				              <div class="font-medium text-lg leading-6 space-y-1 ml-4">
				                
				                <a href='javascript:void(0)' @click='$refs.contactModal.openSendMessageModal(contact)'>
					                <h4>
					                	<svg class="h-6 w-6 text-gray-400 float-left mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
							              </svg> {{contact.name}}  
						            	</h4>
					                <p class="text-red-600">{{contact.position}}</p>
					              </a>
					                <p class="text-red-600"><a v-bind:href="contact.telHref">{{contact.tel}}</a></p>
				                <div>
									<div class="float-left mr-2">
										<a :href='"whatsapp://send?phone=" + formatWhatsAppNumber(contact.tel)'>
										<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
											viewBox="0 0 455.731 455.731" width="20" height="20" xml:space="preserve">
										<g>
											<rect x="0" y="0" style="fill:#1BD741;" width="455.731" height="455.731"/>
											<g>
												<path style="fill:#FFFFFF;" d="M68.494,387.41l22.323-79.284c-14.355-24.387-21.913-52.134-21.913-80.638
													c0-87.765,71.402-159.167,159.167-159.167s159.166,71.402,159.166,159.167c0,87.765-71.401,159.167-159.166,159.167
													c-27.347,0-54.125-7-77.814-20.292L68.494,387.41z M154.437,337.406l4.872,2.975c20.654,12.609,44.432,19.274,68.762,19.274
													c72.877,0,132.166-59.29,132.166-132.167S300.948,95.321,228.071,95.321S95.904,154.611,95.904,227.488
													c0,25.393,7.217,50.052,20.869,71.311l3.281,5.109l-12.855,45.658L154.437,337.406z"/>
												<path style="fill:#FFFFFF;" d="M183.359,153.407l-10.328-0.563c-3.244-0.177-6.426,0.907-8.878,3.037
													c-5.007,4.348-13.013,12.754-15.472,23.708c-3.667,16.333,2,36.333,16.667,56.333c14.667,20,42,52,90.333,65.667
													c15.575,4.404,27.827,1.435,37.28-4.612c7.487-4.789,12.648-12.476,14.508-21.166l1.649-7.702c0.524-2.448-0.719-4.932-2.993-5.98
													l-34.905-16.089c-2.266-1.044-4.953-0.384-6.477,1.591l-13.703,17.764c-1.035,1.342-2.807,1.874-4.407,1.312
													c-9.384-3.298-40.818-16.463-58.066-49.687c-0.748-1.441-0.562-3.19,0.499-4.419l13.096-15.15
													c1.338-1.547,1.676-3.722,0.872-5.602l-15.046-35.201C187.187,154.774,185.392,153.518,183.359,153.407z"/>
											</g>
										</g>
										</svg>
										</a>
									</div>
									<div>
										<!-- <a :href='contact.skype'>
											<svg width="20px" height="20px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="Color-" transform="translate(-400.000000, -660.000000)" fill="#00AEF3">
														<path d="M446.619944,689.095462 C446.967074,687.531907 447.147695,685.912711 447.147695,684.249 C447.147695,671.785081 436.900282,661.677621 424.253998,661.677621 C422.921919,661.677621 421.61524,661.791688 420.339605,662.008694 C418.293509,660.737263 415.87206,660 413.278457,660 C405.943556,660 400,665.859155 400,673.09268 C400,675.507564 400.66604,677.766649 401.823142,679.714137 C401.521167,681.177534 401.360301,682.696575 401.360301,684.249 C401.360301,696.718484 411.610536,706.823161 424.253998,706.823161 C425.687676,706.823161 427.087488,706.692401 428.447789,706.444792 C430.318909,707.435229 432.452493,708 434.724365,708 C442.056444,708 448,702.138063 448,694.910103 C448,692.820727 447.503293,690.8482 446.619944,689.095462 Z M435.997178,695.03808 C434.938852,696.518171 433.375353,697.686663 431.343368,698.515736 C429.336783,699.339245 426.932267,699.759346 424.19191,699.759346 C420.904045,699.759346 418.146754,699.189011 415.993415,698.06225 C414.455315,697.244305 413.188147,696.13702 412.225776,694.76265 C411.252117,693.382716 410.761054,692.011128 410.761054,690.684055 C410.761054,689.860546 411.082785,689.142758 411.714958,688.555729 C412.341486,687.971483 413.145814,687.67936 414.105362,687.67936 C414.889934,687.67936 415.570085,687.910276 416.120414,688.369327 C416.648166,688.811685 417.099718,689.465484 417.463782,690.302904 C417.870179,691.221005 418.310442,691.994436 418.776105,692.598157 C419.227658,693.187967 419.873942,693.680403 420.698024,694.067119 C421.527752,694.451052 422.648166,694.651365 424.022578,694.651365 C425.916275,694.651365 427.468485,694.250739 428.634055,693.46618 C429.777046,692.701095 430.330198,691.77743 430.330198,690.647887 C430.330198,689.760389 430.039511,689.059294 429.446849,688.508433 C428.82032,687.935316 427.999059,687.490176 427.002822,687.178578 C425.96143,686.861415 424.550329,686.51365 422.803387,686.151974 C420.424271,685.651191 418.406397,685.058599 416.803387,684.382542 C415.160865,683.695357 413.837253,682.741089 412.869238,681.547557 C411.887112,680.331768 411.387582,678.809946 411.387582,677.02104 C411.387582,675.318379 411.90969,673.779864 412.942615,672.455573 C413.964252,671.139628 415.460019,670.110242 417.387582,669.411928 C419.286924,668.719179 421.544685,668.368632 424.104421,668.368632 C426.147695,668.368632 427.945437,668.60233 429.446849,669.064163 C430.956726,669.525995 432.226717,670.149191 433.225776,670.91984 C434.233302,671.698835 434.984008,672.525126 435.452493,673.387585 C435.926623,674.25839 436.169332,675.123631 436.169332,675.96105 C436.169332,676.767866 435.853246,677.502347 435.229539,678.139454 C434.60301,678.784907 433.809972,679.110416 432.878645,679.110416 C432.031985,679.110416 431.365945,678.904538 430.908749,678.503912 C430.479774,678.128326 430.033866,677.544079 429.539981,676.709442 C428.969897,675.641106 428.278457,674.798122 427.485419,674.202747 C426.714958,673.624065 425.430856,673.334724 423.661336,673.334724 C422.024459,673.334724 420.686736,673.657451 419.696143,674.300122 C418.742239,674.914971 418.276576,675.624413 418.276576,676.464615 C418.276576,676.976526 418.426152,677.407755 418.736595,677.774996 C419.058325,678.170057 419.518344,678.509477 420.099718,678.798818 C420.700847,679.096505 421.321731,679.335768 421.942615,679.502695 C422.577611,679.677969 423.644403,679.936707 425.109125,680.270562 C426.963311,680.660059 428.665099,681.102417 430.169332,681.57816 C431.696143,682.056686 433.011289,682.646496 434.08937,683.339245 C435.184384,684.043123 436.0508,684.944531 436.668862,686.023996 C437.286924,687.111807 437.600188,688.447227 437.600188,690.002434 C437.600188,691.860894 437.058325,693.555208 435.997178,695.03808 Z" id="Skype"></path>
													</g>
												</g>
											</svg>
										</a> -->
									</div>
				                </div>
				              </div>
				            </div>
				          </li>

				        </ul>
				      </div>
				    </div>

            <div class="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-2 mt-4 sm:mt-16">
              <div class="space-y-5 sm:space-y-4">
                <!-- <h2 class="text-2xl sm:text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl mb-2">Company Info</h2> -->
                <!-- <p class="text-xl leading-7 text-gray-500">We're happy to help. And please remember, trade safe!</p> -->
              </div>
              <div class="lg:col-span-2">
                <ul class="space-y-4 sm:grid sm:grid-cols-2 sm:gap-8 sm:space-y-0 lg:col-gap-8">
                  <!-- <li class='mb-8 sm:mb-0 font-bold'>Telephone &nbsp;<a class='text-red-600 hover:text-red-700 hover:underline' href='tel:+31 621546725'>+31 621546725</a></li> -->
                  <!-- <li></li> -->
                  <li class='mb-8 sm:mb-0 '>
                    <span class='font-bold'>Office Address</span><br/>
                    Ginnekenweg 272<br/>
                    4835 NK Breda<br/>
                    The Netherlands<br/>
                  </li>
				  <li></li>
                  <li class='mb-8 sm:mb-0 '>
                    <span class='font-bold'>Banking Information</span><br/>
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>Bank name:</span> Van Lanschot Kempen, Breda, NL<br />
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>Swift:</span> FVLBNL22<br/>
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>IBAN:</span> NL90FVLB0225666375<br/>
                  </li>
                  <li class='mb-8 sm:mb-0 '>
                    <span class='font-bold'>Company Information</span><br/>
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>Chambers of Commerce:</span> Breda, NL<br/>
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>Chambers Number:</span> 20094175<br/>
                    <span class='text-gray-500 uppercase tracking-tight text-sm'>VAT:</span> NL810851441B01<br/>
                  </li>
                </ul>
              </div>
            </div>

				  </div>
				</div>

        <modal-contact ref='contactModal' action='sendMailToTBS'></modal-contact>

			</div>
		</template>
	</base-layout>
</template>

<script>

import BaseLayout from '@/components/BaseLayout.vue'
import ModalContact from '@/components/ModalContact.vue'

export default {
  name: 'Contact',
  components: {
    BaseLayout,
    ModalContact,
	},
  data: () => ({
		// recaptchaKey: "6Ldp8MoZAAAAABxjylgjXdNZccxftDykLVeOKHoW", // v3
		// recaptchaKey: "6LeI88oZAAAAALmOb9F9e_jGqm-as5XOS4EPkwZJ",
  	contacts: [
  		{
  			name: "Mario Biemans", 
  			email: "mario@thebrokersite.com", 
  			position: "Managing Director", 
  			skype: "skype:mario.biemans?call'",
  			tel: "+31 621546725",
  			telHref: "tel:+31621546725", 
  			picUrl: "/images/contact_mario_tn.png",
  		},
  		{
  			name: "Brian Altman", 
  			email: "brian@thebrokersite.com", 
  			position: "Technical Director", 
  			skype: "skype:bgaltman?call",
  			tel: "+32 468051222",
  			telHref: "tel:+32468051222", 
  			picUrl: "/images/contact_brian_tn.png",
  		},
  		{
  			name: "Pepe Bermúdez", 
  			email: "pepe@thebrokersite.com", 
  			position: "Sales Director", 
  			skype: "skype:www.TheBrokerSite.com?call",
  			tel: "+1 3472846827",
  			telHref: "tel:+13472846827", 
  			picUrl: "/images/contact_pepe_tn.png",
  		},
  		{
  			name: "Rhody Plein", 
  			email: "rhody@thebrokersite.com", 
  			position: "Sales", 
  			skype: "skype:www.TheBrokerSite.com?call",
  			tel: "+31 642965537",
  			telHref: "tel:+31642965537", 
  			picUrl: "/images/contact_rhody_tn.png",
  		},
  		/*{
  			name: "Sheldon Kaye", 
  			email: "sheldon@thebrokersite.com", 
  			position: "Sales",
  			skype: "skype:www.TheBrokerSite.com?call",
  			tel: "+1 7864401411",
  			telHref: "tel:+17864401411",
  			picUrl: "/images/contact_sheldon_tn.png",
  		},*/
  		{
  			name: "Mina Marasigan", 
  			email: "mina@thebrokersite.com", 
  			position: "Back Office", 
  			skype: "skype:mtmarasigan?call",
  			tel: "+63 9999981583",
  			telHref: "tel:+639999981583", 
  			picUrl: "/images/contact_mina_tn.png",
  		},
  		// {
  		// 	name: "Debie Strijker", 
  		// 	email: "debie@thebrokersite.com", 
  		// 	position: "Marketing", 
  		// 	skype: "skype:debie-strijker?call",
  		// 	tel: "+31 683511160",
  		// 	telHref: "tel:+31683511160", 
  		// 	picUrl: "/images/contact_debie_tn.png",
  		// },
		{
			name: "Joel Larracas",
			email: "joel@thebrokersite.com",
			position: "Back Office",
			skype: "skype:live:.cid.deb0a7ccbd910bce?call",
			tel: "+63 9255040381",
			telHref: "tel:+639255040381",
			picUrl: "/images/contact_joel_tn.png",
		},
		{
			name: "Troy Bendanillo",
			email: "troy@thebrokersite.com",
			position: "Developer",
			skype: "skype:live:.cid.5305a9f9a1fdeed3?call",
			tel: "+63 9196488710",
			telHref: "tel:+639196488710",
			picUrl: "/images/contact_troy_tn.png",
		},
	],

  }),
	methods: {
    // onSubmit () {
    //   const bla = this.$refs.invisibleRecaptcha.execute()
		// 	console.log("bla", bla)
    // },
    // onVerify (response) {
    //   console.log('Verify: ' + response)

		// 	// const resp = await this.$http.post("https://www.google.com/recaptcha/api/siteverify", {
		// 	// 	secret: "6LeI88oZAAAAACaFQ82rK_JDB7cKjuiPkepnR7bp",
		// 	// 	response
		// 	// })

		// 	// console.log("ASNWER", resp)
    // },
    // onExpired () {
    //   console.log('Expired')
    // },
    // resetRecaptcha () {
    //   this.$refs.recaptcha.reset() // Direct call reset method
    // }
	formatWhatsAppNumber(phoneString) {
		const firstPhoneString = phoneString.split(',')[0].trim()
		const cleanedString = firstPhoneString.replace(/[^\d]/g, '')
		return cleanedString
	},			

  }
}
</script>
<style>
	.skypeIcon {
    float: left;
    width: 20px;
    height: 20px;
    background-image: url(/images/skype_icon.jpg);
    transition: opacity 0.3s;
    background-size: contain;
    display: block;
    margin-top: 2px;
	}
</style>
